import { Validator } from '@vista-digital/validator';
export const structuredDataConfigValidator = Validator.object({
    enable: Validator.boolean()
});
